import { AlertCircle } from 'lucide-react';

interface NoDataFoundProps {
  title?: string;
  description?: string;
  className?: string;
}

export default function NoDataFound({
  title = "No Data Found",
  description = "Sorry, we couldn't find any results.",
  className = "",
}: NoDataFoundProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center py-16 md:py-24 ${className}`}
    >
      <AlertCircle className="size-12 text-gray-400" />
      <h3 className="mt-4 text-lg font-semibold text-gray-900">{title}</h3>
      <p className="mt-2 text-center text-gray-600 max-w-md">{description}</p>
    </div>
  );
}
